import { createFileRoute } from '@tanstack/react-router'

import { DetalheProjeto } from '@/features/projeto-detalhe/pagina'

export const Route = createFileRoute('/$perfil/projetos/$projetoId')({
  component: Tela,
})

function Tela() {
  const { projetoId } = Route.useParams()
  return <DetalheProjeto projetoId={projetoId} />
}
